/* eslint-disable */
import { Controller } from 'stimulus';
import { triggerCustomEvent, detectIE } from 'lib/helpers';
import events from 'lib/events';
import MediaMatcher from 'lib/media-matcher'
import frameDebounce from 'lib/frame-debounce'

const mediaMatcher = new MediaMatcher();

export default class SiteHeaderController extends Controller {
  static targets = [ "menuGroup", "subMenu", "mobileMenu" ]
  prependIds = ['menu-group-auth', 'menu-group-join-pro', 'menu-group-user']
  isScrolled = false;

  connect() {
    
    if (this.hasMobileMenuTarget) { 
      document.addEventListener('click', this.blurSubMenus);
      this.setupMenuGroupParents();
      this.setupSiteNavigationMediaQueries()
      mediaMatcher.evaluateAll();
      mediaMatcher.addListeners();
    }
    
    window.addEventListener('scroll', this.debouncedScrollCheck);
  }

  disconnect() {
    document.removeEventListener('click', this.blurSubMenus);
    mediaMatcher.removeListeners();
    mediaMatcher.clearQueries();

    window.removeEventListener('scroll', this.debouncedScrollCheck);
  }

  blurSubMenus = (event) => {
    const openSubMenus = document.querySelectorAll('.ez-site-header__submenu-wrapper.is-open');
    const targetSubMenuWrapper = event.target.closest('.ez-site-header__submenu-wrapper');

    if (openSubMenus) {
      openSubMenus.forEach(subMenu => {
        if (targetSubMenuWrapper !== subMenu ) this.toggleSubMenu(subMenu);
      });
    }
  }

  checkScroll = () => {
    if (window.scrollY > 0 && this.isScrolled === false) {
      document.body.classList.add('is-scrolled')
      this.isScrolled = true;
    }
    else if (window.scrollY <= 0 && this.isScrolled === true) {
      document.body.classList.remove('is-scrolled')
      this.isScrolled = false;
    }
  }
  debouncedScrollCheck = frameDebounce(this.checkScroll);

  handleSubMenuClick(event) {
    const subMenuWrapper = event.target.parentNode;
    this.toggleSubMenu(subMenuWrapper)
  }

  toggleSubMenu(subMenuWrapper) {
    subMenuWrapper.classList.toggle("is-closed")
    subMenuWrapper.classList.toggle("is-open")
  }

  createOverlay(action) {
    const overlay = document.createElement('DIV')
    overlay.classList.add('ez-dark-overlay')
    overlay.classList.add('mobile-search-overlay')
    overlay.dataset.action = action
    this.element.appendChild(overlay)
  }

  clearSearchInput() {
    this.element.querySelector('#search').value = '';
  }

  toggleMobileSearch() {
    const searchInput = document.getElementById('search');
    const bodyEl = document.querySelector('body')
    const overlayEl = document.querySelector('.ez-dark-overlay.mobile-search-overlay')
    bodyEl.classList.toggle('is-mobile-search');

    if (bodyEl.classList.contains('is-mobile-search') && !overlayEl) {
      this.createOverlay('click->site-header#toggleMobileSearch')
      searchInput.focus();
      searchInput.value = searchInput.value;
    } else if (!bodyEl.classList.contains('is-mobile-search') && overlayEl) {
      overlayEl.remove();
    }
  }

  setupSiteNavigationMediaQueries() {
    const bodyClass = document.querySelector('body').classList;

    if (bodyClass.contains('is-logged-in') && bodyClass.contains('is-pro')) {
      this.setupProUserMediaQueries()
    } else if (bodyClass.contains('is-logged-in')) {
      this.setupLoggedInMediaQueries()
    } else {
      this.setupLoggedOutMediaQueries()
    } 
  }

  setupProUserMediaQueries() {
    mediaMatcher.addMediaQuery('(max-width: 940px)',
      () => { this.collectAllMenuGroups() },
      () => { if (this.mobileMenuItems()) this.restoreAllMenuGroups() }
    );
  }

  setupLoggedInMediaQueries() {
    mediaMatcher.addMediaQuery('(min-width: 1181px)',
      () => { this.restoreAllMenuGroups() }
    );

    mediaMatcher.addMediaQuery('(max-width: 1180px) and (min-width: 941px)',
      () => {
        const userMenu = document.querySelector('#user-menu .ez-site-header__submenu')
        this.restoreAllMenuGroups()
        this.collectMenuGroup(
          document.querySelector('#menu-group-join-pro'),
          userMenu
        )
      }
    );

    mediaMatcher.addMediaQuery('(max-width: 940px)',
    () => {
      this.collectAllMenuGroups() 
      this.mobileMenuTarget.insertBefore(
        document.querySelector('#menu-group-join-pro'), 
        this.mobileMenuTarget.childNodes[0]
      )
    }
    );
  }

  setupLoggedOutMediaQueries() {
    mediaMatcher.addMediaQuery('(max-width: 1105px)',
      () => { this.collectAllMenuGroups() },
      () => { if (this.mobileMenuItems()) this.restoreAllMenuGroups() }
    );
  }

  setupMenuGroupParents() {
    this.menuGroups.forEach((menuGroup) => {
      const parentMenu = menuGroup.closest('.ez-site-header__submenu-wrapper');
      if (!menuGroup.dataset.parentMenu) menuGroup.dataset.parentMenu = parentMenu.id
    })
  }

  collectMenuGroup(menuGroup, destination) {
    const parentMenu = menuGroup.closest('.ez-site-header__submenu-wrapper');
    parentMenu.classList.add('is-hidden')

    this.prependIds.includes(menuGroup.id) 
      ? destination.insertBefore(menuGroup, destination.childNodes[0]) 
      : destination.appendChild(menuGroup);
  }

  collectAllMenuGroups() {
    this.menuGroups.forEach((menuGroup) => {
      this.collectMenuGroup(menuGroup, this.mobileMenuTarget);
    })
  }

  restoreMenuGroup(menuGroup, destination) {
    const parentMenu = destination.closest('.ez-site-header__submenu-wrapper');
    parentMenu.classList.remove('is-hidden')

    this.prependIds.includes(menuGroup.id) 
      ? destination.insertBefore(menuGroup, destination.childNodes[0]) 
      : destination.appendChild(menuGroup);
  }

  restoreAllMenuGroups() {
    this.menuGroups.forEach((menuGroup) => {
      const parentMenu = document.querySelector(`#${menuGroup.dataset.parentMenu}`);
      const parentSubMenu = parentMenu.querySelector('.ez-site-header__submenu');
      
      const destination = parentSubMenu ? parentSubMenu : parentMenu;
      this.restoreMenuGroup(menuGroup, destination)
    })
  }

  mobileMenuItems() {
    return this.mobileMenuTarget.querySelector('#mobile-menu .ez-site-header__submenu-group');
  }

  get menuGroups() {
    return document.querySelectorAll('.ez-site-header [data-target="site-header.menuGroup"]')
  }

  headerLogin() {
    triggerCustomEvent(events.site_header.header_login);
  }

  headerSignUp() {
    triggerCustomEvent(events.site_header.header_signup);
  }

  sendHeaderJoinProEvent() {
    triggerCustomEvent(events.site_header.header_join_pro);
  }

  sendExploreNavEvent() {
    triggerCustomEvent(events.site_header.explore_nav);
  }

  sendExploreNewestEvent() {
    triggerCustomEvent(events.site_header.explore_newest);
  }

  sendExploreCatsEvent() {
    triggerCustomEvent(events.site_header.explore_cats);
  }

  sendExploreBrusheezyEvent() {
    triggerCustomEvent(events.site_header.explore_brusheezy);
  }

  sendExploreVideezyEvent() {
    triggerCustomEvent(events.site_header.explore_videezy);
  }
}
